import React, { useEffect, useRef, useState } from "react";
import CardComponent from "../../components/CardComponent";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { getCategoryList, designListForLead, addItem, removeItem, updateCategoryId, addKaratCattem, removeKaratCatItem, getKaratFilterList } from "../../redux/features/leadUserCatalogue/leadUserCatalogue";
import { useParams } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { getAllCart } from "../../redux/features/leadUserCart/leadUserCart";
import ModalComponent from "../../components/ModalComponent";
import FilterForm from "../../container/FilterForm";
import TagComponent from "../../components/TagComponent";
import { nanoid } from "nanoid";
// import CartButton from "../../components/CartButton";
import Pagination from "react-js-pagination";
import axiosClient from "../../api/api";
import AppLoader from "../../components/AppLoader";
import { toastComponent } from "../../components/ToastComponent";
import { useLoading } from "../../hooks/useLoading";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Select, { GroupBase, MultiValueProps, StylesConfig } from "react-select";

type KaratOption = { value: string; label: string };
type DynamicMasterOption = { value: { master: string; id: number }; label: string };

/** Renders each selected option as a pill/tag (dropdown stays; only selected display changes) */
function PillMultiValue<Option>({ data, removeProps, innerProps }: MultiValueProps<Option, true>) {
  const label = (data as { label?: string }).label ?? String(data);
  return (
    <span
      {...innerProps}
      className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-medium shadow-sm mr-1 mb-0.5"
      style={{
        backgroundColor: "var(--secondary-color, #16A34A)",
        color: "var(--secondary-contrast-text, #ffffff)",
        textShadow: "0 1px 2px rgba(0,0,0,0.1)",
      }}
    >
      {label}
      <span
        {...removeProps}
        role="button"
        className="ml-0.5 rounded-full p-0.5 hover:opacity-80 transition-colors cursor-pointer"
        aria-label={`Remove ${label}`}
      >
        ×
      </span>
    </span>
  );
}

type Props = {};

const UserCatalogue = React.memo((props: Props) => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const ModalRef = useRef<HTMLDivElement | null>(null);
  const categoryScrollRef = useRef<HTMLDivElement | null>(null);
  const [filterView, setfilterView] = useState<boolean>(false);
  const karatList = useAppSelector((state) => state.leadUserCatalogue.karat);
  const detailsList = useAppSelector((state) => state.leadUserCatalogue.designList);
  const designListPage = useAppSelector((state) => state.leadUserCatalogue.designListPage);
  const categoryid = useAppSelector((state) => state.leadUserCatalogue.categoryid);
  const karat = useAppSelector((state) => state.leadUserCatalogue.karatid);
  const categoryList = useAppSelector((state) => state.leadUserCatalogue.categoryList);
  const categoryName = useAppSelector((state) => state.leadUserCatalogue.catalogueName);
  const counts = useAppSelector((state) => state.leadUserCatalogue.count);
  const hasMore = useAppSelector((state) => state.leadUserCatalogue.hasMore);
  const addedToCart = useAppSelector((state) => state.leadUserCart.add_cart);
  const cataloguesearchFilter = useAppSelector((state) => state.leadUserCatalogue.searchFilter);
  const total_item = useAppSelector((state) => state.leadUserCatalogue.totalitems);
  const filtering = useAppSelector((state) => state.leadUserCatalogue.filtering);
  const loggingOut = useAppSelector((state) => state.userAuth.loggingOut);
  const [dynamicMastersData, setDynamicMastersData] = useState<any[]>([]);
  const [dynamicMastersLoading, setDynamicMastersLoading] = useState(false);
  const [selectedDynamicMasters, setSelectedDynamicMasters] = useState<{ [key: string]: number[] }>({});
  const [minGrossWeight, setMinGrossWeight] = useState("");
  const [maxGrossWeight, setMaxGrossWeight] = useState("");
  const [debouncedMinGrossWeight, setDebouncedMinGrossWeight] = useState("");
  const [debouncedMaxGrossWeight, setDebouncedMaxGrossWeight] = useState("");

  // Loading states
  const { isLoading: initialLoading, withLoading, stopLoading } = useLoading(false);
  const [isDataLoading, setIsDataLoading] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => {
      setDebouncedMinGrossWeight(minGrossWeight.trim());
      setDebouncedMaxGrossWeight(maxGrossWeight.trim());
    }, 500);

    return () => window.clearTimeout(timer);
  }, [minGrossWeight, maxGrossWeight]);

  const getGrossWeightParams = (min: string, max: string) => {
    const params: { min_gross_weight?: number; max_gross_weight?: number } = {};

    if (min !== "") {
      const parsedMin = Number(min);
      if (!Number.isNaN(parsedMin)) {
        params.min_gross_weight = parsedMin;
      }
    }

    if (max !== "") {
      const parsedMax = Number(max);
      if (!Number.isNaN(parsedMax)) {
        params.max_gross_weight = parsedMax;
      }
    }

    return params;
  };

  const isWeightRangeValid = (min: string, max: string) => {
    if (min === "" || max === "") {
      return true;
    }

    const parsedMin = Number(min);
    const parsedMax = Number(max);

    if (Number.isNaN(parsedMin) || Number.isNaN(parsedMax)) {
      return true;
    }

    return parsedMin <= parsedMax;
  };

  const buildDesignListPayload = (page: number) => ({
    page,
    karat,
    catalogue_id: `${id}`,
    category_id: categoryid,
    search_from_category: 1,
    variant_number: cataloguesearchFilter,
    dynamic_masters: Object.values(selectedDynamicMasters).flat(),
    ...getGrossWeightParams(debouncedMinGrossWeight, debouncedMaxGrossWeight),
  });

  useEffect(() => {
    if (loggingOut || !categoryid?.length) return;
    if (cataloguesearchFilter === "") {
      if (!isWeightRangeValid(debouncedMinGrossWeight, debouncedMaxGrossWeight)) {
        toastComponent("Min gross weight cannot be greater than max gross weight", "warning");
        return;
      }

      dispatch(
        designListForLead({
          payload: buildDesignListPayload(filtering ? 1 : designListPage),
        })
      );
    }
  }, [loggingOut, categoryid, karat, cataloguesearchFilter, selectedDynamicMasters, debouncedMinGrossWeight, debouncedMaxGrossWeight]);

  useEffect(() => {
    if (categoryName != undefined && categoryName.length > 0) {
      document.title = `JewelMaker | ${categoryName}`;
    } else {
      document.title = `JewelMaker`;
    }
  }, [categoryName]);

  useEffect(() => {
    if (loggingOut) {
      stopLoading();
      return;
    }
    const loadInitialData = async () => {
      if (id && categoryid.length === 0) {
        await withLoading(() => dispatch(getCategoryList(id)));
      } else if (categoryid.length > 0 || detailsList.length > 0) {
        stopLoading();
      }
    };
    loadInitialData();
  }, [loggingOut, categoryid.length, detailsList.length]);

  useEffect(() => {
    if (loggingOut) return;
    dispatch(getAllCart());
  }, [loggingOut, addedToCart]);

  useEffect(() => {
    if (loggingOut) return;
    dispatch(getKaratFilterList());
  }, [loggingOut]);

  const fetchDynamicMasters = async () => {
    setDynamicMastersLoading(true);
    try {
      const response = await axiosClient.get("/retailerProduct/api/dynamicMaster/catalogue/list/read");
      console.log("Dynamic Masters API Response:", response.data);
      setDynamicMastersData(response.data.data || []);
    } catch (error) {
      console.error("Error fetching Dynamic Masters:", error);
      setDynamicMastersData([]);
    } finally {
      setDynamicMastersLoading(false);
    }
  };

  useEffect(() => {
    fetchDynamicMasters();
  }, []);

  const scrollFilterRow = (ref: React.RefObject<HTMLDivElement | null>, direction: "left" | "right") => {
    if (!ref.current) return;
    const scrollAmount = 200;
    ref.current.scrollBy({ left: direction === "left" ? -scrollAmount : scrollAmount, behavior: "smooth" });
  };

  const handleCategoryPillClick = (categoryId?: number) => {
    if (categoryId === undefined) {
      // ALL: select all categories
      dispatch(updateCategoryId(categoryList.map((c: any) => c.category_id)));
      return;
    }
    const isSelected = categoryid.includes(categoryId);
    if (!isSelected) {
      dispatch(addItem({ id: String(categoryId) }));
    } else {
      if (categoryid.length <= 1) {
        toastComponent("Atleast 1 Category Need", "warning");
        return;
      }
      dispatch(removeItem({ id: String(categoryId) }));
    }
  };

  const karatOptions: KaratOption[] = React.useMemo(
    () => karatList?.map((k: any) => ({ value: k.label, label: k.label })) ?? [],
    [karatList]
  );
  const karatValue: KaratOption[] = React.useMemo(() => karat.map((k) => ({ value: k, label: k })), [karat]);

  const onKaratChange = (newSelection: readonly KaratOption[] | null) => {
    const newNames = (newSelection ?? []).map((o) => o.value);
    if (newNames.length === 0) {
      toastComponent("Atleast 1 Karat Need", "warning");
      return;
    }
    newNames.filter((n) => !karat.includes(n)).forEach((n) => dispatch(addKaratCattem({ id: n })));
    karat.filter((k) => !newNames.includes(k)).forEach((k) => dispatch(removeKaratCatItem({ id: k })));
  };

  const dynamicMastersGroupedOptions: GroupBase<DynamicMasterOption>[] = React.useMemo(
    () =>
      dynamicMastersData.map((master: any) => ({
        label: master.name,
        options: (master.DynamicMasterValues || []).map((v: any) => ({
          value: { master: master.name, id: v.id },
          label: v.value,
        })),
      })),
    [dynamicMastersData]
  );
  const dynamicMastersValue: DynamicMasterOption[] = React.useMemo(() => {
    return Object.entries(selectedDynamicMasters).flatMap(([masterName, ids]) => {
      const master = dynamicMastersData.find((m: any) => m.name === masterName);
      return (ids || []).map((id) => {
        const val = master?.DynamicMasterValues?.find((v: any) => v.id === id);
        return { value: { master: masterName, id }, label: val?.value ?? String(id) };
      });
    });
  }, [selectedDynamicMasters, dynamicMastersData]);

  const onDynamicMastersChange = (newSelection: readonly DynamicMasterOption[] | null) => {
    const next: { [key: string]: number[] } = {};
    (newSelection ?? []).forEach((opt: DynamicMasterOption) => {
      const { master, id } = opt.value;
      if (!next[master]) next[master] = [];
      next[master].push(id);
    });
    setSelectedDynamicMasters(next);
  };

  const selectPortalTarget = document.getElementById("react-select-portal") || document.body;

  const selectStyles: StylesConfig<unknown, true> = {
    control: (base) => ({
      ...base,
      minHeight: 36,
      fontSize: "0.75rem",
      borderColor: "#e2e8f0",
      borderRadius: "0.5rem",
      "&:hover": { borderColor: "#cbd5e1" },
    }),
    valueContainer: (base) => ({
      ...base,
      flexWrap: "wrap",
      gap: 0,
      padding: "4px 8px",
    }),
    placeholder: (base) => ({
      ...base,
      fontSize: "0.75rem",
    }),
    input: (base) => ({
      ...base,
      fontSize: "0.75rem",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 99999,
      borderRadius: "0.5rem",
      overflow: "hidden",
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: 280,
      padding: 0,
    }),
    option: (base, state) => ({
      ...base,
      padding: "6px 12px",
      fontSize: "0.75rem",
      backgroundColor: state.isSelected ? "#f1f5f9" : state.isFocused ? "#f8fafc" : base.backgroundColor,
      color: "#334155",
    }),
    groupHeading: (base) => ({
      ...base,
      padding: "6px 12px",
      fontSize: "0.65rem",
      fontWeight: 600,
      color: "#475569",
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      backgroundColor: "#f1f5f9",
      borderBottom: "1px solid #e2e8f0",
    }),
  };

  const fetchMore = (pagenum: any) => {
    window.scrollTo(0, 0);
    dispatch(
      designListForLead({
        payload: buildDesignListPayload(pagenum),
      })
    );
  };

  return (
    <>
      {initialLoading && <AppLoader message="Loading catalogue..." />}

      {filterView ? (
        <ModalComponent setShow={setfilterView} show={filterView}>
          <FilterForm ref={ModalRef} closeForm={setfilterView} />
        </ModalComponent>
      ) : null}

      <div className="min-h-screen bg-gradient-to-b from-white to-slate-50 text-slate-900">
        <div className="max-w-[1400px] mx-auto px-4 py-6">
          {/* Filter Bar - one horizontal row: Categories | Karat | Dynamic Masters (responsive wrap) */}
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm mb-6 p-4">
            <div className="flex flex-row flex-wrap items-end gap-4 md:gap-6">
              {/* 1. Categories - grows to fill remaining space on the right */}
              <div className="flex flex-col min-w-0 flex-1 basis-full sm:basis-0 sm:min-w-[200px]">
                <span className="text-xs font-semibold text-slate-700 mb-1.5 block">Categories</span>
                <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => scrollFilterRow(categoryScrollRef, "left")}
                    className="flex-shrink-0 w-8 h-8 rounded-full border border-slate-200 bg-white hover:bg-slate-50 flex items-center justify-center transition-colors"
                    aria-label="Scroll categories left"
                  >
                    <ChevronLeft className="w-4 h-4 text-slate-600" />
                  </button>
                  <div
                    ref={categoryScrollRef}
                    className="flex-1 flex gap-2 overflow-x-auto scroll-smooth hide-scroll py-1 min-w-0"
                  >
                    <button
                      type="button"
                      onClick={() => handleCategoryPillClick(undefined)}
                      className={`flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-medium transition-all shadow-sm ${
                        categoryList.length > 0 && categoryid.length === categoryList.length
                          ? ""
                          : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                      }`}
                      style={
                        categoryList.length > 0 && categoryid.length === categoryList.length
                          ? {
                              backgroundColor: "var(--secondary-color, #16A34A)",
                              color: "var(--secondary-contrast-text, #ffffff)",
                              textShadow: "0 1px 2px rgba(0,0,0,0.1)",
                            }
                          : {}
                      }
                    >
                      ALL
                    </button>
                    {categoryList?.map((i: any) => {
                      const isSelected = categoryid.includes(i.category_id);
                      return (
                        <button
                          key={i.category_id}
                          type="button"
                          onClick={() => handleCategoryPillClick(i.category_id)}
                          className={`flex-shrink-0 px-3 py-1.5 rounded-full text-xs font-medium transition-all shadow-sm ${
                            isSelected ? "" : "bg-slate-100 text-slate-700 hover:bg-slate-200"
                          }`}
                          style={
                            isSelected
                              ? {
                                  backgroundColor: "var(--secondary-color, #16A34A)",
                                  color: "var(--secondary-contrast-text, #ffffff)",
                                  textShadow: "0 1px 2px rgba(0,0,0,0.1)",
                                }
                              : {}
                          }
                        >
                          {i.name}
                        </button>
                      );
                    })}
                  </div>
                  <button
                    type="button"
                    onClick={() => scrollFilterRow(categoryScrollRef, "right")}
                    className="flex-shrink-0 w-8 h-8 rounded-full border border-slate-200 bg-white hover:bg-slate-50 flex items-center justify-center transition-colors"
                    aria-label="Scroll categories right"
                  >
                    <ChevronRight className="w-4 h-4 text-slate-600" />
                  </button>
                </div>
              </div>

              {/* 2. Karat - dropdown; selected values shown as pills */}
              <div className="flex flex-col min-w-0 flex-1 sm:flex-initial sm:min-w-[140px] md:min-w-[180px]">
                <span className="text-xs font-semibold text-slate-700 mb-1.5 block">Karat</span>
                <div className="w-full min-w-0">
                  <Select<KaratOption, true>
                    isMulti
                    options={karatOptions}
                    value={karatValue}
                    onChange={onKaratChange}
                    menuPortalTarget={selectPortalTarget}
                    menuPosition="fixed"
                    placeholder="Select Karat"
                    styles={selectStyles as StylesConfig<KaratOption, true>}
                    closeMenuOnSelect={false}
                    components={{ MultiValue: PillMultiValue }}
                  />
                </div>
              </div>

              {/* 3. Dynamic Masters - dropdown with groups; selected values shown as pills */}
              <div className="flex flex-col min-w-0 flex-1 sm:flex-initial sm:min-w-[160px] md:min-w-[200px] lg:min-w-[240px]">
                <span className="text-xs font-semibold text-slate-700 mb-1.5 block">Keyword/Tags</span>
                <div className="w-full min-w-0">
                  <Select<DynamicMasterOption, true, GroupBase<DynamicMasterOption>>
                    isMulti
                    options={dynamicMastersGroupedOptions}
                    value={dynamicMastersValue}
                    onChange={onDynamicMastersChange}
                    placeholder={dynamicMastersLoading ? "Loading..." : "Select options"}
                    isDisabled={dynamicMastersLoading}
                    menuPortalTarget={selectPortalTarget}
                    menuPosition="fixed"
                    styles={selectStyles as StylesConfig<DynamicMasterOption, true, GroupBase<DynamicMasterOption>>}
                    closeMenuOnSelect={false}
                    getOptionValue={(opt) => `${opt.value.master}__${opt.value.id}`}
                    components={{ MultiValue: PillMultiValue }}
                  />
                </div>
              </div>

              {/* 4. Gross weight range */}
              <div className="flex flex-col min-w-0 flex-1 sm:flex-initial sm:min-w-[160px] md:min-w-[200px]">
                <span className="text-xs font-semibold text-slate-700 mb-1.5 block">Gross Weight (g)</span>
                <div className="flex items-center gap-2">
                  <input
                    type="number"
                    min="0"
                    step="0.001"
                    value={minGrossWeight}
                    onChange={(e) => setMinGrossWeight(e.target.value)}
                    placeholder="Min"
                    className="w-full rounded-lg border border-slate-200 px-2 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-slate-300"
                  />
                  <span className="text-xs text-slate-400">-</span>
                  <input
                    type="number"
                    min="0"
                    step="0.001"
                    value={maxGrossWeight}
                    onChange={(e) => setMaxGrossWeight(e.target.value)}
                    placeholder="Max"
                    className="w-full rounded-lg border border-slate-200 px-2 py-1.5 text-xs focus:outline-none focus:ring-2 focus:ring-slate-300"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <main>
            {/* Mobile: extra filter trigger */}
            <div className="flex sm:hidden gap-3 mb-4">
              <TagComponent icon="/icons8-filter-24.png" CTA="Filter" onClick={() => setfilterView(true)} />
            </div>

            {/* Product Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-5 items-start">
              {detailsList.map((i) => (
                <CardComponent
                  key={nanoid()}
                  cartData={i.CartData}
                  category_id={i.Category.id}
                  design_id={i.id}
                  karat={i.design_weights[0].karat}
                  link={`/catalogues/${id}/${i.id}/${i.design_weights[0].karat}`}
                  img={i.ImageURL}
                  varient={i.variant_number}
                  weight={i.design_weights[0].net_weight}
                />
              ))}
            </div>

            {detailsList.length === 0 && <p className="text-center font-bold text-gray-500 py-8">No Design available</p>}

            {/* Pagination */}
            <div className="pagination_container mt-8">
              <Pagination activePage={designListPage} itemsCountPerPage={20} totalItemsCount={counts} pageRangeDisplayed={5} onChange={fetchMore} />
            </div>
          </main>
        </div>

        {/* Back to Top Button */}
        <a
          href="#top"
          className="fixed right-6 bottom-6 h-10 w-10 rounded-full grid place-items-center bg-slate-900 text-white shadow-lg hover:shadow-xl transition-shadow"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo(0, 0);
          }}
        >
          ↑
        </a>
      </div>
    </>
  );
});

export default UserCatalogue;
